import { render, staticRenderFns } from "./SortOption_LocalPavPattern.vue?vue&type=template&id=f975734c&scoped=true&"
import script from "./SortOption_LocalPavPattern.vue?vue&type=script&lang=js&"
export * from "./SortOption_LocalPavPattern.vue?vue&type=script&lang=js&"
import style0 from "./SortOption_LocalPavPattern.vue?vue&type=style&index=0&id=f975734c&scoped=true&lang=css&"
import style1 from "./SortOption_LocalPavPattern.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f975734c",
  null
  
)

export default component.exports